import { createStore, select, withProps } from '@ngneat/elf';
import { RoutingProfileStats } from '@tmx/data-access';
import { shareReplay, Subject } from 'rxjs';

export interface OnboardingTourStats {
  assetHasLicense: boolean;
  hasAsset: boolean;
  hasMapset: boolean;
  hasVehicle: boolean | null;
  hasVehicleGroup: boolean | null;
}

interface OnboardingTourProps {
  hasAssets: boolean;
  hasAssignedLicenses: boolean;
  hasInvitedDrivers: boolean;
  hasMapSets: boolean;
  hasRoutingProfiles: boolean;
  hasVehicleGroups: boolean;
  isInitialized: boolean;
}

const onboardingTourStore = createStore(
  { name: 'onboardingTour' },
  withProps<OnboardingTourProps>({
    isInitialized: false,
    hasAssets: false,
    hasAssignedLicenses: false,
    hasInvitedDrivers: false,
    hasVehicleGroups: false,
    hasRoutingProfiles: false,
    hasMapSets: false,
  })
);

export const isInitialized$ = onboardingTourStore.pipe(
  select((state) => state.isInitialized)
);

export const hasAssets$ = onboardingTourStore.pipe(
  select(({ hasAssets }) => hasAssets),
  shareReplay({ bufferSize: 1, refCount: true })
);

export const hasAssignedLicenses$ = onboardingTourStore.pipe(
  select(({ hasAssignedLicenses }) => hasAssignedLicenses),
  shareReplay({ bufferSize: 1, refCount: true })
);

export const completeItineraryByName$ = new Subject<string>();

export const onboardingTourStoreSnapshot = () => onboardingTourStore.getValue();

export function updateInitialStats(
  accountStats: OnboardingTourStats,
  routingProfileStats: RoutingProfileStats
) {
  onboardingTourStore.update((state) => ({
    ...state,
    hasAssets: accountStats.hasAsset,
    hasAssignedLicenses: accountStats.assetHasLicense,
    hasVehicleGroups: accountStats.hasVehicleGroup === true,
    hasMapSets: accountStats.hasMapset,
    hasRoutingProfiles: routingProfileStats.totalCount > 0,
  }));
}

export function setInitialized() {
  onboardingTourStore.update((state) => ({ ...state, isInitialized: true }));
}
